window.select2 = require('select2');
window.Chart = require('chart.js');
window.FingerprintJS = require('@fingerprintjs/fingerprintjs');